export const WATER_PRICE_LIMITS = Object.freeze({
  mineral: Object.freeze({ min: 100, max: 800 }),
  pure: Object.freeze({ min: 300, max: 800 })
});

export const DEFAULT_WATER_PRICES = Object.freeze({
  mineral: 350,
  pure: 520
});

export const isWaterPriceWithinLimits = (value, limits) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue)
    && numericValue >= limits.min
    && numericValue <= limits.max;
};
